import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ManageAuditProgramListSearch } from 'app/model/manage-audit-program-list-search';
import { AuditProgramScopeBean } from 'app/model/audit-program-scope-bean';
import { AuditProgramAIRDTO } from 'app/model/audit-program-air-dto';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { CommonDTO } from 'app/model/common-dto';
import { AuditProgramAIRItemDocumentDTO } from 'app/model/audit-program-air-item-document-dto';
import { ManageAuditProgramDto } from 'app/model/manage-audit-program-dto';
import { UserPermissionDto } from 'app/model/user-permission-dto';
import { AuditProgramResponse } from 'app/model/audit-program-response-dto';
import { UrlConfigService } from './url-config.service';

@Injectable({
  providedIn: 'root',
})
export class ManageAuditProgarmService {
  // url = environment.SERVER_URL;
  token = '';
  TOKEN = 'token';
  auditProgramData: ManageAuditProgramDto;

  url: string;
  constructor(private http: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }
  getManageAuditProgramTiles(manageAuditProgramListSearch: ManageAuditProgramListSearch) {
    return this.http.post(`${this.url}manageAuditProgram/list`, manageAuditProgramListSearch);
  }

  deleteAuditProgramTiles(manageAuditProgramListSearch: ManageAuditProgramListSearch) {
    return this.http.post(
      `${this.url}manageAuditProgram/crudOperation`,
      manageAuditProgramListSearch
    );
  }

  getAuditProgramScopeList(auditProgramScopeBean: AuditProgramScopeBean) {
    return this.http.post(`${this.url}auditProgram/scope/list`, auditProgramScopeBean);
  }

  auditProgramScopeCrudOperation(auditProgramScopeBean: AuditProgramScopeBean) {
    return this.http.post(`${this.url}auditProgram/scope/crudOperation`, auditProgramScopeBean);
  }

  getAIRTemplateList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}auditProgram/air/airTemplateList`, commonDTO);
  }

  getAuditProgramAuditorDepartmentList(auditProgramAIRDTO: AuditProgramAIRDTO) {
    return this.http.post(`${this.url}auditProgram/air/air-dept-list`, auditProgramAIRDTO);
  }

  getAuditProgramAIRList(auditProgramAIRDTO: AuditProgramAIRDTO) {
    return this.http.post(`${this.url}auditProgram/air/list`, auditProgramAIRDTO);
  }

  getAuditorBenchAIRList(auditProgramAIRDTO: AuditProgramAIRDTO) {
    return this.http.post(`${this.url}auditor/air/list`, auditProgramAIRDTO);
  }

  auditProgramAIRCrudOperation(auditProgramAIRDTO: AuditProgramAIRDTO) {
    return this.http.post(`${this.url}auditProgram/air/crudOperation`, auditProgramAIRDTO);
  }

  deleteAuditProgramAIRItemDocumentByDocumentId(
    auditProgramAIRItemDocumentDTO: AuditProgramAIRItemDocumentDTO
  ) {
    return this.http.post(
      `${this.url}auditProgram/air/deleteAIRItemDocument`,
      auditProgramAIRItemDocumentDTO
    );
  }

  getAuditProgramAIRItemDocumentList(
    auditProgramAIRItemDocumentDTO: AuditProgramAIRItemDocumentDTO
  ) {
    return this.http.post(
      `${this.url}auditProgram/air/aIRItemDocumentList`,
      auditProgramAIRItemDocumentDTO
    );
  }

  getAuditProgramAIRLog(auditProgramAIRItemDocumentDTO: AuditProgramAIRItemDocumentDTO) {
    return this.http.post(`${this.url}auditProgram/air/airLog`, auditProgramAIRItemDocumentDTO);
  }

  getAirAuditeeActionStandardRepoDocList(auditProgramAIRDTO: AuditProgramAIRDTO) {
    return this.http.post(`${this.url}standardrepo/doc/DocumentList`, auditProgramAIRDTO);
  }

  uploadAuditProgramAIRItemDocument(formData) {
    localStorage.setItem('isUpload', '1');
    return this.http.post<any>(`${this.url}auditProgram/air/uploadAIRItemDocument`, formData, {
      headers: {
        Authorization: localStorage.getItem(this.TOKEN),
        'Content-Type': 'multipart/form-data;charset=UTF-8',
      },
      reportProgress: true,
      observe: 'events',
    });
  }

  downloadAuditProgramAIRItemDocument(
    auditProgramAIRItemDocumentDTO: AuditProgramAIRItemDocumentDTO
  ) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: authKey,
      }),
    };
    return this.http.post(
      `${this.url}auditProgram/air/downloadAIRItemDocument`,
      auditProgramAIRItemDocumentDTO,
      httpOptions
    );
  }

  auditProgramEditTriggerDetail(manageAuditProgramListSearch: ManageAuditProgramListSearch) {
    return this.http.post(
      `${this.url}auditProgram/editTriggerDetail`,
      manageAuditProgramListSearch
    );
  }

  auditProgramTrigger(manageAuditProgramListSearch: ManageAuditProgramListSearch) {
    return this.http.post(`${this.url}auditProgram/trigger`, manageAuditProgramListSearch);
  }

  downloadAuditProgramData(auditProgramScopeBean: AuditProgramScopeBean) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: authKey,
      }),
    };
    return this.http.post(
      `${this.url}auditProgram/scope/export-audit-program-scope`,
      auditProgramScopeBean,
      httpOptions
    );
  }

  exportManageSiteExcel(userPermissionList) {
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    return this.http.post(
      `${this.url}userPermission/exportManageSiteExcelTemplate`,
      userPermissionList,
      httpOptions
    );
  }

  uploadManageSiteExcel(manageAuditProgramDto: ManageAuditProgramDto) {
    return this.http.post(
      `${this.url}userPermission/uploadManageSiteExcelTemplate`,
      manageAuditProgramDto
    );
  }

  getDepartmentHeaderList(manageAuditProgramDto: ManageAuditProgramDto) {
    return this.http.post(`${this.url}userPermission/departmentHeaderList`, manageAuditProgramDto);
  }

  getUserPermissionList(manageAuditProgramDto: ManageAuditProgramDto) {
    return this.http.post(
      `${this.url}userPermission/getManageSitePermissionList`,
      manageAuditProgramDto
    );
  }

  saveGridData(userPermissionList: UserPermissionDto) {
    return this.http.post(`${this.url}userPermission/saveGridData`, userPermissionList);
  }

  getAIRTemplateIdByAuditProgramId(commonDTO: CommonDTO) {
    return this.http.post(
      `${this.url}auditProgram/air/air-template-id-by-audit-program-id`,
      commonDTO
    );
  }

  exportAuditSiteWiseExcel(auditProgramResponse: AuditProgramResponse) {
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    return this.http.post(
      `${this.url}userPermission/exportManageSiteExcelTemplate`,
      auditProgramResponse,
      httpOptions
    );
  }

  exportRole(manageAuditProgramDto: ManageAuditProgramListSearch) {
    return this.http.post(`${this.url}auditProgram/roleType`, manageAuditProgramDto);
  }

  downloadExcel(manageAuditProgramDto: ManageAuditProgramListSearch) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: authKey,
      }),
    };
    return this.http.post(`${this.url}auditProgram/getExcel`, manageAuditProgramDto, httpOptions);
  }

  getRoleForAuditLevelSecurity(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}auditProgram/roleTypeSecurity`, commonDTO);
  }

  getRoleForAuditLevelSecurityUsingSiteId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}auditProgram/roleTypeSecurityUsingSiteId`, commonDTO);
  }
  getCalendarData(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}manageAuditProgramCalendar/list`, commonDTO);
  }

  getStandardRepoDocListAudiorAIRdownload(auditProgramAIRDTO: AuditProgramAIRDTO) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: authKey,
      }),
    };
    return this.http.post(
      `${this.url}standardrepodoc/air/downloadstandardAIRItemDocument`,
      auditProgramAIRDTO,
      httpOptions
    );
  }
}
